export const validateIsEmail = (email: string): boolean => {
  const regEx = /^([A-Za-z0-9_\-.+])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,})$/;
  return regEx.test(email);
};
